export const ExternalUrl = {
    nmsHubDiscord: 'https://discord.gg/5hrYrjtWQg',
    meogiYT: 'https://www.youtube.com/@Meogione',
    silent: 'https://www.youtube.com/channel/UC9G1Ds0NlZngSvhIaJDgLWQ',
    assistantNMS: 'https://nmsassistant.com',
    nmscd: 'https://nmscd.com',
    githubRepo: 'https://github.com/NMSCD/Creature-Builder',
    goatFungusSaveEditor: 'https://github.com/goatfungus/NMSSaveEditor',
    monkeyman192: 'https://github.com/monkeyman192',
    nmsdk: 'https://github.com/monkeyman192/NMSDK',
    mbinCompiler: 'https://github.com/monkeyman192/MBINCompiler',
    threejs: 'https://threejs.org',
}

export const ExternalImages = {
    assistantNMS: 'https://avatars.githubusercontent.com/u/54021133?s=200',
    kurt: 'https://kurtlourens.com/assets/images/KurtAvatar.svg',
    meogi: 'https://yt3.ggpht.com/GAZQndl844qHRyPW7vDwDJJos01TFx7i4OqKX-Qco293KN3q9YAB5QC2aCJ3XxSS-uSdIrYHVg=s88-c-k-c0x00ffffff-no-rj',
    nmsHub: 'https://cdn.discordapp.com/icons/780508359375454208/a_82923637ed4e1c4a1f7ac1b1c3aa4410.webp',
    monkeyMan: 'https://avatars.githubusercontent.com/u/8000597?v=4',
    nmsdk: './assets/img/nmsdk.png',
}


export const patreonApiUrl = 'https://www.patreon.com';
export const patreonApiOAuthUrl = `${patreonApiUrl}/oauth2/authorize`;